import script from "./ReporteAlmacen.vue?vue&type=script&setup=true&lang=js"
export * from "./ReporteAlmacen.vue?vue&type=script&setup=true&lang=js"

import "./ReporteAlmacen.vue?vue&type=style&index=0&id=05ceead3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ceead3"]])

export default __exports__